import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
const { color, size } = ids || {};
const tagPrimary = css `
  background: ${color.action.primary.ids_color_action_primary_base};
`;
const tagSecundary = css `
  background: ${color.action.secondary.ids_color_action_secondary_base};
`;
const badgePrimary = css `
  background: ${color.feedbacks.ids_color_feedback_success};
`;
const badgeSecundary = css `
  background: ${color.action.secondary.ids_color_action_secondary_variant};
`;
const getBadgeStyle = (variant) => {
    if (variant === "primary")
        return badgePrimary;
    if (variant === "secondary")
        return badgeSecundary;
};
const getTagStyle = (variant) => {
    if (variant === "primary")
        return tagPrimary;
    if (variant === "secondary")
        return tagSecundary;
};
export const StyledOfferLabel = styled.div `
  border: 0px none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: ${({ type }) => type === "badge" ? "100%" : size.general.ids_size_general_4x}};
  padding: ${({ type }) => type === "badge"
    ? size.general.ids_size_general_8x
    : `${size.general.ids_size_general_2x} ${size.general.ids_size_general_8x}`};
  ${({ type, variant }) => type === "badge" ? getBadgeStyle(variant) : getTagStyle(variant)}
`;
//# sourceMappingURL=OfferLabel.style.js.map